import React from 'react';
import {Rating} from "@mui/material";

interface RatingBarProps {
  rating: number
}

const RatingBar: React.FC<RatingBarProps> = (props) => {
  return (
    <div>
      <Rating name="half-rating-read" value={props.rating} precision={0.1} readOnly/>
      <span className="expert-rating">{props.rating}</span>
    </div>
  );
};

export default RatingBar;